import { Component, computed, effect, input, model, output } from '@angular/core';
import { LoadingAndFeedbackState } from '../../models/loading-and-feedback-state.type';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { IconComponent } from '../icon/icon.component';
import { DndDirective } from '../../directives/drag-and-drop/dnd.directive';

@Component({
  selector: 'work-ui-dropzone-multi',
  templateUrl: './dropzone-multi.component.html',
  styleUrls: ['./dropzone-multi.component.scss'],
  standalone: true,
  imports: [DndDirective, IconComponent, LoadingSpinnerComponent, TranslateModule],
})
export class DropzoneMultiComponent {
  public multiple = input(true);
  public hasLoadingState = input(false);
  public disabled = input(false);
  public disabledReason = input('');
  /** Flachere Variante fuer enge Kontexte wie Wizard-Schritte oder Inline-Formulare. */
  public compact = input(false);
  // resets to 'none' on 'success' after 1000 ms
  public loadingState = model<LoadingAndFeedbackState>('none');
  public disableLoadingStateReset = input(false);
  public acceptPdf = input(false);
  public acceptImage = input(false);
  public acceptWord = input(false);
  public acceptPowerpoint = input(false);
  public acceptExcel = input(false);
  public acceptCsv = input(false);
  /** XML, z.B. camt.054-Bankdateien. */
  public acceptXml = input(false);
  public acceptVideo = input(false);
  public acceptAudio = input(false);
  public filesReceived = output<File[]>();

  protected accept = computed(() => {
    const accept: string[] = [];
    if (this.acceptPdf()) accept.push('.pdf');
    if (this.acceptImage()) accept.push('.jpeg', '.jpg', '.png', '.gif', '.heic');
    if (this.acceptWord()) accept.push('.docx');
    if (this.acceptPowerpoint()) accept.push('.pptx');
    if (this.acceptExcel()) accept.push('.xlsx');
    if (this.acceptCsv()) accept.push('.csv');
    if (this.acceptXml()) accept.push('.xml');
    if (this.acceptVideo()) accept.push('.mp4', '.mov');
    if (this.acceptAudio()) accept.push('.mp3', '.m4a', '.aac', '.wav', '.ogg', '.webm', '.flac');
    return accept;
  });

  private loadingStateEffect = effect(() => {
    if (this.loadingState() === 'success' && !this.disableLoadingStateReset()) {
      // wait a short time to show result state after call
      setTimeout(() => {
        this.loadingState.set('none');
      }, 1000);
    }
  });

  /**
   * on file drop handler
   */
  public onFilesDropped($event: any) {
    this.prepareFilesList($event as File[]);
  }

  /**
   * handle file from browsing
   */
  public fileBrowseHandler(files: any) {
    this.prepareFilesList(files.target.files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  public prepareFilesList(files: File[]) {
    if (this.hasLoadingState()) {
      this.loadingState.set('loading');
    }
    this.filesReceived.emit(files);
  }
}
